module.exports = __webpack_public_path__ + "static/desktop_35-26e2ee610b3a820c6a15727d9a9ebef5.png";